export default {"src":"/_next/static/media/wide-logo.f7a98410.svg","height":702,"width":3162,"blurWidth":0,"blurHeight":0};